import React, { useState, useEffect, useRef } from "react";

export default function ChatBot({ isOpenExternal, setIsOpenExternal }) {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: "bot",
      text: "Здравствуйте! Я ИИ-ассистент ОТРА-М. Чем могу помочь?",
    },
  ]);

  const messagesEndRef = useRef(null);

  // 1. Синхронизация с внешней кнопкой "Обсудить проект"
  useEffect(() => {
    if (isOpenExternal) {
      setIsOpen(true);
      if (messages.length === 1) {
        setTimeout(() => {
          // АРГУМЕНТ ВСТАВЛЕН ТУТ
          setMessages((prev) => [
            ...prev,
            {
              role: "bot",
              text: "Вижу, Вы хотите обсудить проект. Расскажите подробнее: вас интересует автоматизация бизнес-процессов, техническая поддержка, разработка систем или информационная безопасность?",
            },
          ]);
        }, 500);
      }
    }
  }, [isOpenExternal, messages.length]);

  // 2. Автопрокрутка вниз
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // 3. Функция переключения
  const toggleChat = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (setIsOpenExternal) setIsOpenExternal(newState);
  };

  // 4. Отправка сообщения на FastAPI
  const handleSend = async () => {
    if (!input.trim()) return;

    const userMsg = { role: "user", text: input };

    // АРГУМЕНТ ВСТАВЛЕН ТУТ
    setMessages((prev) => [...prev, userMsg]);

    setInput("");
    setIsLoading(true);

    try {
      const response = await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: input }),
      });

      if (!response.ok) throw new Error("Ошибка сервера");

      const data = await response.json();

      // АРГУМЕНТ ВСТАВЛЕН ТУТ
      setMessages((prev) => [...prev, { role: "bot", text: data.reply }]);
    } catch (error) {
      // АРГУМЕНТ ВСТАВЛЕН ТУТ
      setMessages((prev) => [
        ...prev,
        {
          role: "bot",
          text: "Извините, мой ИИ-модуль сейчас перезагружается. Оставьте контакты в форме ниже, и я отвечу вам лично!",
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 font-sans">
      {isOpen && (
        <div className="bg-white w-[350px] h-[500px] shadow-2xl rounded-3xl mb-4 flex flex-col border border-slate-100 overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-300">
          <div className="p-5 bg-blue-600 text-white flex justify-between items-center shadow-lg">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <div>
                <p className="font-bold text-sm leading-none uppercase tracking-tighter italic">
                  Ассистент
                </p>
                <p className="text-[9px] opacity-70 mt-1 uppercase tracking-widest">
                  ОТРА-М Онлайн
                </p>
              </div>
            </div>
            <button
              onClick={toggleChat}
              className="hover:rotate-90 transition-transform p-1"
            >
              ✕
            </button>
          </div>

          <div className="flex-1 p-4 overflow-y-auto bg-slate-50 space-y-4">
            {messages.map((m, i) => (
              <div
                key={i}
                className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}
              >
                {m.role === "user" ? (
                  // Для пользователя оставляем обычный текст, так как он не пишет HTML
                  <div className="max-w-[85%] p-3 rounded-2xl text-sm leading-relaxed shadow-sm bg-blue-600 text-white rounded-br-none">
                    {m.text}
                  </div>
                ) : (
                  // Для бота рендерим HTML через dangerouslySetInnerHTML
                  <div
                    className="max-w-[85%] p-3 rounded-2xl text-sm leading-relaxed shadow-sm bg-white text-slate-700 border border-slate-100 rounded-bl-none bot-html-content"
                    dangerouslySetInnerHTML={{ __html: m.text }}
                  />
                )}
              </div>
            ))}
            {isLoading && (
              <div className="flex items-end gap-2 mb-4 animate-fade-in">
                {/* Аватарка Отрика (Кастомный технологичный робот) */}
                <div className="w-9 h-9 bg-gradient-to-tr from-blue-700 via-blue-600 to-indigo-500 rounded-xl flex items-center justify-center text-white shrink-0 shadow-lg shadow-blue-500/20 border border-blue-400/30">
                  <svg
                    className="w-6 h-6 animate-pulse"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://w3.org"
                  >
                    {/* Антенна со светящимся индикатором */}
                    <circle cx="16" cy="5" r="1.5" fill="#38BDF8" />
                    <path d="M16 6.5V9" stroke="#38BDF8" strokeWidth="1.5" strokeLinecap="round" />
                    
                    {/* Наушники / Боковые крепления */}
                    <rect x="4" y="14" width="2" height="6" rx="1" fill="#94A3B8" />
                    <rect x="26" y="14" width="2" height="6" rx="1" fill="#94A3B8" />
                    <path d="M5 14C5 8.5 9.5 5 16 5C22.5 5 27 8.5 27 14" stroke="#94A3B8" strokeWidth="1.5" strokeLinecap="round" />
                    
                    {/* Корпус головы робота */}
                    <rect x="6" y="9" width="20" height="15" rx="4" fill="#F8FAFC" />
                    
                    {/* Экран для глаз */}
                    <rect x="9" y="12" width="14" height="6" rx="2" fill="#0F172A" />
                    
                    {/* Светящиеся глаза ИИ */}
                    <circle cx="12.5" cy="15" r="1.25" fill="#38BDF8" />
                    <circle cx="19.5" cy="15" r="1.25" fill="#38BDF8" />
                    
                    {/* Доброжелательная улыбка (линия интерфейса) */}
                    <path d="M13 20C14 21 18 21 19 20" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" />
                    
                    {/* Микрофон гарнитуры */}
                    <path d="M26 18C24 20 22 21 20 21" stroke="#94A3B8" strokeWidth="1" strokeLinecap="round" />
                  </svg>
                </div>
                
                {/* Облако с пульсирующими точками */}
                <div className="bg-slate-100 text-slate-800 px-4 py-3 rounded-2xl rounded-bl-none max-w-[75%] shadow-sm border border-slate-200/50">
                  <div className="flex items-center gap-1.5 h-5">
                    <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.3s]"></span>
                    <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.15s]"></span>
                    <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></span>
                  </div>
                </div>
              </div>
            )}


            <div ref={messagesEndRef} />
          </div>

          <div className="p-4 bg-white border-t border-slate-100 flex gap-2">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
              placeholder="Введите сообщение..."
              className="flex-1 bg-slate-100 border-none rounded-xl px-4 py-3 text-sm outline-none focus:ring-2 ring-blue-500/50"
            />
            <button
              onClick={handleSend}
              disabled={isLoading}
              className="bg-blue-600 text-white px-4 rounded-xl hover:bg-blue-700 disabled:opacity-50 transition-colors"
            >
              OK
            </button>
          </div>
        </div>
      )}

      <button
        onClick={toggleChat}
        className={`w-16 h-16 rounded-full shadow-2xl flex items-center justify-center text-white transition-all duration-500 hover:scale-110 ${
          isOpen ? "bg-slate-800 rotate-90" : "bg-blue-600"
        }`}
      >
        {isOpen ? "✕" : "💬"}
      </button>
    </div>
  );
}
